/*
* @描述:  自定义表单详情pc端
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-11-06 10:19:49
*/
<template>
    <div class="m_custom_form_detail_wrap">
        <el-form ref="customForm"
                 :model="customForm"
                 label-position="top"
                 size="small">
            <el-row>
                <el-col v-for="field in formInfoList" :key="field.field_key">
                    <div v-if="field.field_type==='form_module'"
                         class="form_module_title">
                        <span class="field_name" v-text="field.field_name"></span>
                    </div>
                    <el-form-item v-else-if="field.field_type==='input'" :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value">
                            <span v-text="customForm[field.field_key].value||'--'"></span>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='textarea'" :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value">
                            <span v-text="customForm[field.field_key].value||'--'"></span>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='number'" :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value">
                            <span v-text="customForm[field.field_key].text||'--'"></span>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='money'&&field.field_key!=='purchase_price'"
                                  :prop="field.field_key">
                        <div slot="label">
                            <span v-text="field.field_name"></span>
                            <span v-text="customForm[field.field_key].currency.includes('CNY')?'（CNY-人民币）：':'（USD-美元）：'"></span>
                        </div>
                        <div class="detail_value" v-text="customForm[field.field_key].text||'--'">
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='compute_mode'" :label="field.field_name"
                                  :prop="field.field_key">
                        <span class="detail_value" v-text="customForm[field.field_key].value||'--'"></span>
                        <span v-if="customForm[field.field_key].chinese_text"
                              class="chinese_text"
                              v-text="customForm[field.field_key].chinese_text"></span>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='telephone'" :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value"
                             v-text="customForm[field.field_key].prefix +' '+ customForm[field.field_key].value">
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='radio'" :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value">
                            <span v-text="customForm[field.field_key].text?customForm[field.field_key].text:'--'"></span>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='radio_customer'" :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="link-label"
                             @click="handleClickRelateCompanyDetail"
                             v-text="customForm[field.field_key].text?customForm[field.field_key].text:'--'">
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='radio_project'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="link-label"
                             @click="handleClickRelateProjectDetail"
                             v-text="customForm[field.field_key].text?customForm[field.field_key].text:'--'">
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='checkbox'" :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value">
                            <div v-if="customForm[field.field_key].text&&customForm[field.field_key].text.length">
                                <div v-if="field.tag_interaction" class="flex_wrap">
                                    <span v-for="item in customForm[field.field_key].text"
                                          class="is_tag_interaction"
                                          v-text="item"></span>
                                </div>
                                <span v-else v-text="customForm[field.field_key].text.join()"></span>
                            </div>
                            <span v-else>--</span>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='checkbox_user_tag'" :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value">
                            <span v-if="customForm[field.field_key].text&&customForm[field.field_key].text.length"
                                  class="flex_wrap">
                                <span v-for="item in customForm[field.field_key].text"
                                      class="is_tag_interaction"
                                      v-text="item.name"></span>
                            </span>
                            <span v-else>--</span>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='checkbox_quotation'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <ul class="quotation_list">
                            <li v-for="(item,index) in customForm[field.field_key].text" class="quotation_item">
                            </li>
                        </ul>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='cascader'" :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value"
                             v-text="customForm[field.field_key].text&&customForm[field.field_key].text.length?customForm[field.field_key].text:'--'">
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='date'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value"
                             v-text="customForm[field.field_key].value||'--'">
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='date_range'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value"
                             v-text="customForm[field.field_key].text||'--'">
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='address'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value">
                            <span v-text="customForm[field.field_key].text||'--'"></span>
                            <span v-if="customForm[field.field_key].detail_address"
                                  v-text="'/'+customForm[field.field_key].detail_address"></span>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='contact'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value">
                            <div v-if="customForm[field.field_key].text && customForm[field.field_key].text.length"
                                 style="display: flex;gap: 12px;flex-wrap: wrap">
                                <div v-for="item in customForm[field.field_key].text" class="custom_contact_field_wrap">
                                    <PersonnelCard v-if="item.id" :userId="item.id">
                                        <template slot="container">
                                            <img :src="item.avatar?item.avatar:defaultImg" alt=""
                                                 class="avatar">
                                            <span class="name" v-text="item.name"></span>
                                        </template>
                                    </PersonnelCard>
                                </div>
                            </div>
                            <div v-else>--</div>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='department'" :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value">
                            <span v-if="customForm[field.field_key].text&&customForm[field.field_key].text.length"
                                  v-text="customForm[field.field_key].text.map(map => map.department_name).join('、')"></span>
                            <span v-else>--</span>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='image'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div v-if="customForm[field.field_key].length" class="image_outer_wrap">
                            <ul class="upload_image_list">
                                <li v-for="item in customForm[field.field_key]"
                                    :key="item.file_path"
                                    class="upload_image_item">
                                    <el-image :preview-src-list="customForm[field.field_key].map(img=>img.file_path)"
                                              :src="item.file_path"
                                              fit="cover">
                                    </el-image>
                                </li>
                            </ul>
                        </div>
                        <div v-else>--</div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='file'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div v-if="customForm[field.field_key].length" class="file_upload_wrap file_upload_detail_wrap">
                            <ul class="upload_file_list upload_file_list_detail">
                                <li v-for="file in customForm[field.field_key]" class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        <span class="line"></span>
                                        <span class="handle_icon_wrap"
                                              @click="handleClickDownloadFile(file)">
                                                <i class="iconfont icon-daochu"></i>
                                            </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-else>--</div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='invoice'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <ul v-if="customForm[field.field_key].length" class="invoice_list">
                            <li class="invoice_item" v-for="item in customForm[field.field_key]">
                                <div class="invoice_title_wrap">
                                    <span class="purchaser_name" v-text="item.purchaser_name||item.title"></span>
                                    <el-link :underline="false" type="primary"
                                             @click="handleClickPreviewInvoiceFile(item)">发票预览
                                    </el-link>
                                </div>
                                <div class="invoice_total_amount" v-text="'￥'+item.total_amount"></div>
                            </li>
                        </ul>
                        <div v-else>--</div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='checkbox_approval'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <ul v-if="customForm[field.field_key].text&&customForm[field.field_key].text.length"
                            class="related_approval_list">
                            <li v-for="(item,index) in customForm[field.field_key].text"
                                class="related_approval_item">
                                <div class="flex_js_wrap">
                                    <div class="related_approval_title flex_wrap">
                                        <h4 v-text="item.approval_set_name"></h4>
                                        <div :class="'relate_approve_status_' + item.status"
                                             class="relate_approve_status"
                                             v-text="item.status === 0 ? '审批中' : item.status === 1 ? '已通过' : item.status === 2 ? '已拒绝' : '已撤回'"></div>
                                    </div>
                                    <div class="flex_wrap">
                                        <el-link :underline="false" type="primary"
                                                 @click="handleClickRelatedApprovalDetail(item)">详情
                                        </el-link>
                                    </div>
                                </div>
                                <div class="flex_wrap approve_created_at">
                                    <span v-text="item.user.name"></span>
                                    <span>提交于</span>
                                    <span v-text="item.created_at"></span>
                                </div>
                                <div v-if="item.overview_fields&&item.overview_fields.length"
                                     class="overview_fields_wrap">
                                    <div v-if="item.is_pack_up">
                                        <OverviewFields :overviewFields="item.overview_fields"/>
                                    </div>
                                    <div class="ta_c">
                                        <el-link :underline="false" type="primary"
                                                 @click="handleApproveOverViewField(item)">
                                            {{ item.is_pack_up ? '收起' : '展开' }}
                                            <i :class="item.is_pack_up?'icon-shangjiantou':'icon-xiajiantou'"
                                               class="iconfont"></i>
                                        </el-link>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div v-else>--</div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='checkbox_check_record'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <ul v-if="customForm[field.field_key].text&&customForm[field.field_key].text.length"
                            class="related_check_record_list">
                            <li v-for="(item,index) in customForm[field.field_key].text"
                                class="related_check_record_item">
                                <div class="relate_title">
                                    <h4 v-if="item.user" v-text="item.user.name+'的打卡记录'"></h4>
                                    <el-link :underline="false" type="primary"
                                             @click="handleClickRelatedCheckRecordDetail(item)">详情
                                    </el-link>
                                </div>
                                <div class="flex_wrap">
                                    <i class="iconfont icon-messgae-clock"></i>
                                    <h4 v-text="item.start_time||'--'"></h4>
                                    <h4 v-if="item.punch_type==='INTERVAL'">～</h4>
                                    <h4 v-if="item.punch_type==='INTERVAL'" v-text="item.end_time||'--'"></h4>
                                </div>
                                <div class="flex_wrap">
                                    <i class="iconfont icon-weizhi1"></i>
                                    <span v-text="item.address||'--'"></span>
                                </div>
                            </li>
                        </ul>
                        <div v-else>--</div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='id_card'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value">
                            <span v-text="customForm[field.field_key].text||'--'"></span>
                            <el-popover v-if="customForm[field.field_key].value"
                                        placement="top"
                                        popper-class="id_card_detail_popper"
                                        trigger="click"
                                        popper-append-to-body
                                        width="380">
                                <span v-if="customForm[field.field_key].value"
                                      slot="reference"
                                      class="handle_icon_wrap"
                                      @click.stop>
                                     <i class="iconfont icon-shenfenzheng"></i>
                                </span>
                                <el-form size="small">
                                    <el-form-item v-if="customForm[field.field_key].name" label="姓名：" prop="name">
                                        <span v-text="customForm[field.field_key].name"></span>
                                    </el-form-item>
                                    <el-form-item v-if="customForm[field.field_key].birthday" label="出生日期："
                                                  prop="birthday">
                                        <span v-text="customForm[field.field_key].birthday"></span>
                                    </el-form-item>
                                    <el-form-item v-if="customForm[field.field_key].address" label="家庭住址："
                                                  prop="name">
                                        <span v-text="customForm[field.field_key].address"></span>
                                    </el-form-item>
                                    <el-form-item label="身份证号：" prop="text">
                                        <span v-text="customForm[field.field_key].text"></span>
                                    </el-form-item>
                                </el-form>
                                <img alt=""
                                     class="ic_card_icon"
                                     src="https://download.hecoos.com/enlightv/2025-02/02d922ef5bd0a7ded22b965632d634ea.png">
                            </el-popover>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='paying_teller'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value">
                            <span v-text="customForm[field.field_key].value||'--'"></span>
                            <el-popover placement="bottom"
                                        popper-class="paying_teller_detail_popper"
                                        trigger="click"
                                        width="350">
                                <span v-if="customForm[field.field_key].value"
                                      slot="reference"
                                      class="handle_icon_wrap"
                                      @click.stop>
                                     <i class="iconfont icon-zhanghu"></i>
                                </span>
                                <el-form class="custom_detail_form" label-position="top" size="small">
                                    <el-form-item label="账户类型" prop="account_type">
                                        <span v-text="customForm[field.field_key].account_type===1?'个人账户':'对公账户'"></span>
                                    </el-form-item>
                                    <el-form-item label="户名" prop="account_name">
                                        <span v-text="customForm[field.field_key].account_name"></span>
                                    </el-form-item>
                                    <el-form-item label="账号" prop="card_number">
                                        <span v-text="customForm[field.field_key].card_number"></span>
                                    </el-form-item>
                                    <el-form-item label="所属银行" prop="bank_name">
                                        <span v-text="customForm[field.field_key].bank_name"></span>
                                    </el-form-item>
                                    <el-form-item v-if="customForm[field.field_key].bank_branch"
                                                  label="银行支行"
                                                  prop="bank_branch">
                                        <span v-text="customForm[field.field_key].bank_branch"></span>
                                    </el-form-item>
                                </el-form>
                            </el-popover>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='rate'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="detail_value" v-text="customForm[field.field_key].text"></div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='table'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div class="vertical_table_outer_wrap">
                            <ul class="vertical_table_list">
                                <li v-for="(row,index) in customForm[field.field_key]"
                                    :key="index"
                                    class="vertical_table_item">
                                    <el-form :model="row"
                                             label-position="top"
                                             size="small">
                                        <div v-for="child in field._child.filter(field=>!field.initial_display)"
                                             :key="child.field_key">
                                            <el-form-item v-if="child.field_type==='input'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <el-input v-model="row[child.field_key].value"
                                                          :placeholder="child.placeholder"
                                                          maxlength="30"></el-input>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='textarea'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <el-input v-model="row[child.field_key].value"
                                                          :placeholder="child.placeholder"
                                                          :rows="3"
                                                          type="textarea"></el-input>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='number'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <div class="number_input_wrap">
                                                    <el-input-number v-model="row[child.field_key].value"
                                                                     :controls="false"
                                                                     :max="child.max"
                                                                     :min="child.min"
                                                                     :placeholder="child.placeholder"
                                                                     @blur="handleInputNumberBlur(child,row,field._child)">
                                                    </el-input-number>
                                                    <span v-if="child.unit"
                                                          class="unit_span"
                                                          v-text="child.unit"></span>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='money'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <el-input v-model="row[child.field_key].text"
                                                          :class="child.currency.length>1?'money_input':'money_unit_input'"
                                                          :placeholder="child.placeholder"
                                                          @blur="handleInputPriceBlur(child,row,field._child)">
                                                    <el-select v-if="child.currency.length>1"
                                                               slot="suffix"
                                                               v-model="row[child.field_key].currency"
                                                               placeholder="请选择币种"
                                                               s-ze="mini"
                                                               style="width: 110px!important;">
                                                        <el-option v-if="child.currency.includes('CNY')" key="CNY"
                                                                   label="CNY-人民币"
                                                                   value="CNY"></el-option>
                                                        <el-option v-if="child.currency.includes('USD')" key="USD"
                                                                   label="USD-美元"
                                                                   value="USD"></el-option>
                                                    </el-select>
                                                    <span v-else slot="suffix" class="unit_text"
                                                          v-text="row[child.field_key].currency==='CNY'?'CNY-人民币':'USD-美元'"></span>
                                                </el-input>
                                                <span v-if="row[child.field_key].currency==='CNY'"
                                                      class="chinese_text"
                                                      v-text="row[child.field_key].chinese_text"></span>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='compute_mode'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <el-input v-model="row[child.field_key].value"
                                                          disabled
                                                          placeholder="系统自动计算"></el-input>
                                                <span v-if="row[child.field_key].chinese_text"
                                                      class="chinese_text"
                                                      v-text="row[child.field_key].chinese_text"></span>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='telephone'"
                                                          :prop="child.field_key">
                                                <span slot="label" class="label_btn_wrap">
                                                    <span v-text="child.field_name"></span>
                                                    <ul v-if="child.phone_type==='3'" class="phone_type_list">
                                                        <li :class="{'active':row[child.field_key].phone_type==='1'}"
                                                            class="phone_type_item"
                                                            @click="handleTelePhoneTypeChange(row, child.field_key, '1')">手机</li>
                                                        <li :class="{'active':row[child.field_key].phone_type==='2'}"
                                                            class="phone_type_item"
                                                            @click="handleTelePhoneTypeChange(row, child.field_key, '2')">固话</li>
                                                    </ul>
                                                </span>
                                                <el-input v-model="row[child.field_key].value"
                                                          :maxlength="row[child.field_key].phone_type==='1'?11:8"
                                                          :placeholder="child.placeholder"
                                                          class="telephone_input">
                                                    <el-input
                                                            slot="prepend"
                                                            v-model="row[child.field_key].prefix"
                                                            :placeholder="row[child.field_key].phone_type==='1'?'+86':'区号'"
                                                            :readonly="row[child.field_key].phone_type==='1'"
                                                            maxlength="4"
                                                            style="width: 64px">
                                                    </el-input>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='radio'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key"
                                                          filterable>
                                                <el-select :key="child.field_key"
                                                           v-model="row[child.field_key].value"
                                                           @change="handleRadioCheckChange(child,row,row._child)">
                                                    <el-option v-for="item in child.options"
                                                               :label="item.label"
                                                               :value="item.value"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='checkbox'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <el-select :key="child.field_key"
                                                           v-model="row[child.field_key].value"
                                                           :placeholder="child.placeholder"
                                                           collapse-tags
                                                           filterable
                                                           multiple
                                                           @change="handleCheckBoxCheckChange(child,row,row._child)">
                                                    <el-option v-for="item in child.options"
                                                               :label="item.label"
                                                               :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='cascader'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <el-cascader v-model="row[child.field_key].value"
                                                             :options="child.options"
                                                             :placeholder="child.placeholder"
                                                             :props="{value:'value',label:'label',children:'_child'}"
                                                             @change="handleCascaderSelectChange(child,row)">
                                                </el-cascader>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='date'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <el-date-picker v-if="child.date_type==='month'"
                                                                v-model="row[child.field_key].value"
                                                                :disabled="child.default"
                                                                :editable="false"
                                                                :picker-options=child.date_picker_options
                                                                :placeholder="child.default?'由系统提供时间':child.placeholder"
                                                                format="yyyy-MM"
                                                                type="month"
                                                                value-format="yyyy-MM">
                                                </el-date-picker>
                                                <el-date-picker v-else-if="child.date_type==='date'"
                                                                v-model="row[child.field_key].value"
                                                                :disabled="child.default"
                                                                :editable="false"
                                                                :picker-options=child.date_picker_options
                                                                :placeholder="child.default?'由系统提供时间':child.placeholder"
                                                                format="yyyy-MM-dd"
                                                                type="date"
                                                                value-format="yyyy-MM-dd">
                                                </el-date-picker>
                                                <el-time-picker v-else-if="child.date_type==='time'"
                                                                v-model="row[child.field_key].value"
                                                                :editable="false"
                                                                :picker-options="child.date_picker_options"
                                                                :placeholder="child.default?'由系统提供时间':child.placeholder"
                                                                format="HH:mm"
                                                                value-format="HH:mm">
                                                </el-time-picker>
                                                <el-date-picker v-else-if="child.date_type==='datetime'"
                                                                v-model="row[child.field_key].value"
                                                                :disabled="child.default"
                                                                :editable="false"
                                                                :picker-options=child.date_picker_options
                                                                :placeholder="child.default?'由系统提供时间':child.placeholder"
                                                                format="yyyy-MM-dd HH:mm"
                                                                type="datetime"
                                                                value-format="yyyy-MM-dd HH:mm">
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='date_range'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <div class="date_range_input_wrap">
                                                    <el-date-picker v-if="child.date_type==='daterange'"
                                                                    v-model="row[child.field_key].value"
                                                                    :editable="false"
                                                                    :end-placeholder="child.end_placeholder"
                                                                    :start-placeholder="child.start_placeholder"
                                                                    format="yyyy/MM/dd"
                                                                    range-separator="～"
                                                                    type="daterange"
                                                                    value-format="yyyy-MM-dd"
                                                                    @change="handleSelectDateRange(child,row)">
                                                    </el-date-picker>
                                                    <div v-else-if="child.date_type==='timerange'"
                                                         class="flex_wrap">
                                                        <el-time-picker v-model="row[child.field_key].value "
                                                                        :editable="false"
                                                                        :placeholder="child.start_placeholder"
                                                                        format="HH:mm"
                                                                        value-format="HH:mm"
                                                                        @change="handleSelectTimeRange(child,row)">
                                                        </el-time-picker>
                                                        <span>～</span>
                                                        <el-time-picker v-model="row[child.field_key].value[1]"
                                                                        :editable="false"
                                                                        :placeholder="child.end_placeholder"
                                                                        format="HH:mm"
                                                                        value-format="HH:mm"
                                                                        @change="handleSelectTimeRange(child,row)">
                                                        </el-time-picker>
                                                    </div>
                                                    <el-date-picker v-else-if="child.date_type === 'datetimerange'"
                                                                    v-model="row[child.field_key].value"
                                                                    :editable="false"
                                                                    :end-placeholder="child.end_placeholder"
                                                                    :start-placeholder="child.start_placeholder"
                                                                    format="yyyy/MM/dd HH:mm"
                                                                    range-separator="～"
                                                                    type="datetimerange"
                                                                    value-format="yyyy-MM-dd HH:mm"
                                                                    @change="handleSelectDateRange(child,row)">
                                                    </el-date-picker>
                                                    <el-input v-if="child.auto_computed"
                                                              v-model="row[child.field_key].duration"
                                                              disabled
                                                              placeholder="自动计算时长"
                                                              style="width: 160px">
                                                        <span slot="suffix">天</span>
                                                    </el-input>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='address'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <div class="address_input_wrap">
                                                    <el-cascader :ref="'address_cascader_' + child.field_key"
                                                                 v-model="row[child.field_key].value"
                                                                 :options="child.options"
                                                                 :placeholder="child.area_accuracy_placeholder"
                                                                 :style="{'width':child.is_show_detail_address?'180px':'100%'}"
                                                                 filterable
                                                                 separator="-"
                                                                 @change="handleAddressCascaderChange(child,row)">
                                                    </el-cascader>
                                                    <el-input v-if="child.is_show_detail_address"
                                                              v-model="row[child.field_key].detail_address"
                                                              :placeholder="child.detail_address_placeholder"
                                                              maxlength="30">
                                                    </el-input>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='contact'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <el-select :ref="`${child.field_key}_contact_select`"
                                                           v-model="row[child.field_key].value"
                                                           :disabled="child.default&&child.default_can_edit==='2'"
                                                           :multiple-limit="child.select_range.indexOf('1') > -1 ? 0:1"
                                                           :placeholder="child.placeholder"
                                                           :remote-method="getUserList"
                                                           collapse-tags
                                                           filterable
                                                           multiple
                                                           remote
                                                           @remove-tag="handleRemoveContactTag($event,child,row)">
                                                    <el-option v-for="user in userList"
                                                               :key="user.uid"
                                                               :disabled="userInfo.user&&user.id === userInfo.user.id&&!child.select_range.includes('2')"
                                                               :label="`${user.name}/${user.phone}（${user.department_name}）`"
                                                               :value="user.uid"
                                                               @click.native="handleClickContactItem(user,child,row,`table_item_form_${field.field_key}_${index}`)">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='department'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <el-select :ref="`${child.field_key}_department_select`"
                                                           v-model.trim="row[child.field_key].titles"
                                                           :disabled="child.default"
                                                           :placeholder="child.placeholder"
                                                           clearable
                                                           collapse-tags
                                                           multiple
                                                           @remove-tag="handleRemoveDepartmentTag($event,child,row,formInfoList)">
                                                    <el-option :value="[]" style="height: auto;padding: 0">
                                                        <el-tree :ref="`${child.field_key}_department_tree`"
                                                                 :data="departmentList"
                                                                 :expand-on-click-node='false'
                                                                 :props="{children: 'children',label: 'relate_name'}"
                                                                 :show-checkbox="child.select_range==='2'"
                                                                 check-on-click-node
                                                                 check-strictly
                                                                 default-expand-all
                                                                 highlight-current
                                                                 node-key="id"
                                                                 size="mini"
                                                                 @check-change="(data,checked,indeterminate) =>handleDepartmentCheckChange(data,checked,indeterminate,child,row,formInfoList,`table_item_form_${field.field_key}_${index}`)">
                                                        </el-tree>
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='image'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <div class="image_outer_wrap">
                                                    <div v-if="is_preview_mode" class="image_upload_wrap"
                                                         @click="handleClickPreviewModeBtn">
                                                        <i class="el-icon-plus"></i>
                                                    </div>
                                                    <ul v-else class="upload_image_list">
                                                        <li v-for="item in row[child.field_key]"
                                                            :key="item.file_path"
                                                            class="upload_image_item">
                                                            <el-image
                                                                    :preview-src-list="row[child.field_key].map(img=>img.file_path)"
                                                                    :src="item.file_path"
                                                                    fit="cover">
                                                            </el-image>
                                                            <i class="el-icon-error"
                                                               @click="row[child.field_key].splice(index,1)"></i>
                                                        </li>
                                                        <li class="image_upload_wrap">
                                                            <input accept="image/*"
                                                                   class="upload_input"
                                                                   multiple
                                                                   type="file"
                                                                   @change="handleClickUploadImg($event,child,row)">
                                                            <i class="el-icon-plus"></i>
                                                        </li>
                                                    </ul>
                                                    <p class="image_hint">
                                                        从本地上传图片，支持多张上传、多种图片格式。</p>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='file'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <div v-if="is_preview_mode" class="file_outer_wrap"
                                                     @click="handleClickPreviewModeBtn">
                                                    <img alt=""
                                                         src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"
                                                         width="36">
                                                    <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                                    <p class="file_type_hint">支持Word、Excel、PDF等常见类型</p>
                                                </div>
                                                <div v-else class="file_upload_wrap">
                                                    <div v-if="row[child.field_key].length===0"
                                                         class="file_outer_wrap">
                                                        <img alt=""
                                                             src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"
                                                             width="36">
                                                        <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                                        <p class="file_type_hint">支持Word、Excel、PDF等常见类型</p>
                                                        <input class="upload_input"
                                                               multiple
                                                               type="file"
                                                               @change="handleUploadFileChange($event,child,row)">
                                                    </div>
                                                    <ul v-else class="upload_file_list">
                                                        <li v-for="(file,file_idx) in row[child.field_key]"
                                                            class="upload_file_item">
                                                            <div class="file_left_wrap">
                                                                <img alt="" class="file_img"
                                                                     src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                                                <div class="file_info_wrap">
                                                                    <p class="file_name"
                                                                       v-text="file.file_name"></p>
                                                                    <p class="file_size"
                                                                       v-text="file.file_size"></p>
                                                                </div>
                                                            </div>
                                                            <div class="file_right_wrap">
                                                                <el-tooltip content="预览"
                                                                            effect="dark"
                                                                            placement="top">
                                                                        <span class="handle_icon_wrap"
                                                                              @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                                                </el-tooltip>
                                                                <span class="line"></span>
                                                                <el-tooltip content="下载"
                                                                            effect="dark"
                                                                            placement="top">
                                                                        <span class="handle_icon_wrap"
                                                                              @click="handleClickDownloadFile(file)">
                                                                            <i class="iconfont icon-daochu"></i>
                                                                        </span>
                                                                </el-tooltip>
                                                            </div>
                                                        </li>
                                                        <li class="upload_file_btn_wrap">
                                                            <i class="el-icon-plus"></i>
                                                            <span>添加附件</span>
                                                            <input class="upload_input"
                                                                   multiple
                                                                   type="file"
                                                                   @change="handleUploadFileChange($event,child,row)">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='invoice'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <ul class="invoice_list">
                                                    <li v-for="item in row[child.field_key]" class="invoice_item">
                                                        <div class="invoice_title_wrap">
                                                            <span class="purchaser_name"
                                                                  v-text="item.purchaser_name||item.title"></span>
                                                            <el-link :underline="false" type="primary"
                                                                     @click="handleClickPreviewInvoiceFile(item)">
                                                                发票预览
                                                            </el-link>
                                                        </div>
                                                        <div class="invoice_total_amount"
                                                             v-text="'￥'+item.total_amount"></div>
                                                    </li>
                                                </ul>
                                                <div v-if="is_edit_mode"
                                                     class="upload_btn_outer_wrap"
                                                     @click="handleClickUploadInvoice(child,row)">
                                                    <div class="add_btn"><i class="iconfont icon-shangchuan"></i>上传发票
                                                    </div>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='checkbox_approval'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <div v-if="is_edit_mode" class="upload_btn_outer_wrap">
                                                    <div class="add_btn"><i class="el-icon-plus"></i>关联审批单
                                                    </div>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='id_card'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <div class="id_card_wrap">
                                                    <el-input v-model="row[child.field_key].value"
                                                              :placeholder="child.placeholder"
                                                              @focus="handleClickAddIdCardInfo(child,row,`table_item_form_${field.field_key}_${index}`)">
                                                        <span slot="suffix">
                                                            <i v-if="child.upload_recognition"
                                                               class="iconfont icon-saoyisao"
                                                               @click="handleClickRecognition(field,customForm)"></i>
                                                            <i class="iconfont icon-shenfenzheng"
                                                               @click="handleClickAddIdCardInfo(child,row,`table_item_form_${field.field_key}_${index}`)"></i>
                                                        </span>
                                                    </el-input>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='paying_teller'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <div class="paying_teller_wrap">
                                                    <el-select :ref="`paying_teller_select_${child.field_key}`"
                                                               v-model="row[child.field_key].text"
                                                               :placeholder="child.placeholder"
                                                               clearable
                                                               popper-class="paying_teller_select_popper"
                                                               @clear="handlePayingTellerSelectClear(child,row)"
                                                               @focus="handlePayingTellerSelectFocus(child)">
                                                        <el-option v-for="bank in child.options"
                                                                   :value="bank.card_number">
                                                            <div :class="{'active':row[child.field_key].card_number===bank.card_number}"
                                                                 class="teller_info_wrap"
                                                                 @click.stop="handleClickSelectPayingTeller(bank,child,row)">
                                                                <div class="left_info_wrap">
                                                                    <img alt="" class="bank_logo"
                                                                         src="https://download.hecoos.com/enlightv/2023-50/Mai6CwZRQfRjb23YEACA.png">
                                                                    <div class="account_info_wrap">
                                                                        <div>
                                                                            <span class="account_name"
                                                                                  v-text="bank.account_name"></span>
                                                                            <span class="account_type"
                                                                                  v-text="bank.account_type===1?'个人账户':'对公账户'"></span>
                                                                        </div>
                                                                        <div class="bank_name"
                                                                             v-text="bank.bank_name + '（' + bank.card_number + '）'"></div>
                                                                    </div>
                                                                </div>
                                                                <div class="right_handle_wrap">
                                                                    <span class="handle_icon_wrap" @click.stop>
                                                                        <i class="iconfont icon-bianji"
                                                                           @click="handleClickEditPayingTeller(child,row,bank)"></i>
                                                                    </span>
                                                                    <span class="handle_icon_wrap" @click.stop>
                                                                        <i class="iconfont icon-shanchu1"
                                                                           @click="handleClickDelPayingTeller(child,row,bank)"></i>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </el-option>
                                                        <el-option value="">
                                                            <div class="add_paying_teller_btn_wrap"
                                                                 @click.stop="handleClickAddPayingTeller(child,row)">
                                                                <el-link :underline="false"
                                                                         type="primary"><i class="el-icon-plus"></i>添加账户
                                                                </el-link>
                                                            </div>
                                                        </el-option>
                                                    </el-select>
                                                    <i class="iconfont icon-saoyisao"
                                                       @click="handleClickRecognition(child,row)"></i>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-else-if="child.field_type==='rate'"
                                                          :label="child.field_name"
                                                          :prop="child.field_key">
                                                <div class="flex_wrap">
                                                    <el-rate v-model="row[child.field_key].value"
                                                             :allow-half="child.point_system==='10'"
                                                             void-color="#BFBFBF"
                                                             @change="handleRateFieldChange(child,row)"></el-rate>
                                                    <span v-text="row[child.field_key].text"></span>
                                                </div>
                                            </el-form-item>
                                        </div>
                                    </el-form>
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='purchase_details'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <el-table :data="customForm[field.field_key]" border class=" custom_table">
                            <el-table-column label="产品名称" min-width="194" prop="product_name"></el-table-column>
                            <el-table-column align="right" label="数量" prop="num" width="110">
                                <template slot-scope="{row}">
                                    <span v-if="row.return_num"
                                          style="color:rgba(228, 65, 68, 1);">退货({{ row.return_num }})</span>
                                    <span v-text="row.num"></span>
                                </template>
                            </el-table-column>
                            <el-table-column align="right" class-name="tableInputColumn" label="单价（元）" prop="price"
                                             width="96"></el-table-column>
                            <el-table-column align="right" label="小计金额（元）" prop="total_price"
                                             width="124"></el-table-column>
                            <el-table-column v-if="field.show_field.indexOf('stock') > -1" label="入库仓库"
                                             prop="stock_name" width="124"></el-table-column>
                            <el-table-column v-if="field.show_field.indexOf('note') > -1" label="说明" prop="note"
                                             width="164"></el-table-column>
                        </el-table>
                        <div class="show_summary">
                            总数量：<span
                                v-text="customForm[field.field_key].reduce((total, item) => total + item.num, 0)"></span>
                            <span class="line"></span>
                            总金额：<span
                                v-text="customForm[field.field_key].reduce((total, item) => total + Number(item.total_price), 0)"></span>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='customer_contact'"
                                  :label="field.field_name"
                                  :prop="field.field_key">
                        <div v-if="customForm[field.field_key].text" class="detail_value">
                            <span v-text="customForm[field.field_key].text.map(item=>item.name).join()"></span>
                        </div>
                        <div v-else class="detail_value">
                            <span>--</span>
                        </div>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='order_amount_compute_mode'">
                        <div slot="label" class="flex_wrap">
                            <span v-text="field.field_name"></span>
                            <span v-if="field.filling_method==='1'" class="handle_icon_wrap"
                                  @click="handleClickShowFormula(field.formula)">
                                <i class="iconfont icon-yiwen"></i>
                            </span>
                        </div>
                        <span class="detail_value" v-text="customForm[field.field_key]||'--'"></span>
                    </el-form-item>
                    <el-form-item v-else-if="field.field_type==='goods'">
                        <ul class="m_detail_order_goods_list">
                            <li v-for="row in customForm[field.field_key]" :key="row.order_goods_id"
                                class="order_goods_item">
                                <div class="table_goods_info_wrap goods_info_wrap">
                                    <div v-if="(row.deliver_status!==0||row.order_return_goods_id)"
                                         class="ship_status">
                                        <img v-if="row.deliver_status == 1&&row.is_virtual===1"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/424WFeARXDkJEsSZHDjt.svg">
                                        <img v-else-if="row.deliver_status == 2&&row.is_virtual===1"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/QxeNcB2BsHmwpsXPKhkM.svg">
                                        <img v-else-if="row.deliver_status == 3&&row.is_virtual===1"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2024-27/iBpD5aYdCjNW2ywzH2HK.svg">
                                        <img v-else-if="row.order_return_goods_id"
                                             alt=""
                                             src="https://download.hecoos.com/enlightv/2025-09/fb4eb92deb7cdb38c73f9ff150f6faf8.png"></img>
                                    </div>
                                    <div class="goods_image_wrap">
                                        <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                             alt="">
                                        <div class="good_status_text"
                                             v-text="row.goods_status===0?'已下架':row.goods_deleted_at?'已删除':''"></div>
                                    </div>
                                    <div class="goods_name_wrap">
                                        <div class="goods_name">
                                            <span v-text="row.goods_name"></span>
                                            <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                                  v-text="'：'+row.goods_sku_name"></span>
                                            <el-tag :class="{'del_text':row.action==='del'}"
                                                    :type="row.type===1?'success':'warning'"
                                                    size="mini">
                                                {{ row.type === 1 ? '销售' : '租借' }}
                                            </el-tag>
                                        </div>
                                        <div class="flex_js_wrap">
                                            <div class="goods_price"
                                                 v-text="row.order_return_goods_id?'¥'+row.price:'¥'+row.price.text"></div>
                                            <div class="goods_num" v-text="'X' + row.num"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                                    <ul class="goods_spec_list">
                                        <template v-if="row.is_expand">
                                            <li v-for="child in row._child"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li v-for="child in row._child.slice(0,1)"
                                                :key="child.part_id"
                                                class="good_part_item"
                                                v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                            </li>
                                        </template>
                                    </ul>
                                    <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                        <span class="handle_expand_text"
                                              v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                        <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                           class="iconfont"></i>
                                    </div>
                                </div>
                                <div class="goods_amount_wrap">
                                    <div class="cost_guide_price_wrap flex_wrap">
                                        <img alt=""
                                             src="https://download.hecoos.com/enlightv/2025-10/d83f6be23fa8ac527f87c9296c8e1e39.svg">
                                        <span v-text="row.order_return_goods_id?'--':'¥' + row.cost_price"></span>
                                        <img alt=""
                                             src="https://download.hecoos.com/enlightv/2025-10/4283680c308ffa0dee2c8105fda1ed53.svg">
                                        <span v-text="row.order_return_goods_id?'--':'¥' + row.guide_price"></span>
                                    </div>
                                    <div>
                                        <div v-if="row.order_return_goods_id">
                                            <div v-text="'¥' + row.refund_subtotal_price"></div>
                                        </div>
                                        <div v-else>
                                            <div>
                                                <span>总价：</span>
                                                <span class="subtotal_price"
                                                      v-text="'¥' + row.subtotal_price.text"></span>
                                            </div>
                                            <div v-if="row.guide_price&&row.price.value&&Number(row.guide_price)!==row.price.value"
                                                 class="ta_r">
                                                <div :class="'discounts_'+goodsDiscountsTextOrClass(row,'class')"
                                                     class="discounts_text"
                                                     v-text="goodsDiscountsTextOrClass(row,'text')"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <van-field label="租借起止时间："
                                           readonly
                                           input-align="right"
                                           label-width="7em"
                                           v-if="row.type===2&&row.is_virtual===1&&!row.order_return_goods_id"
                                           :value="row.start_at +' ~ '+ row.end_at">
                                </van-field>
                            </li>
                        </ul>
                    </el-form-item>
                    <div v-else-if="field.field_type==='money_compute_mode'">
                        <div v-if="order_procurement_show" class="mb_12">
                            <div class="flex_js_wrap mb_8">
                                <h4>代采产品</h4>
                                <el-link v-if="Object.keys(business_data).length===0"
                                         :underline="false"
                                         type="primary"
                                         @click="handleClickShowPurchaseDetail">查看代采明细
                                </el-link>
                            </div>
                            <div class="flex_js_wrap">
                                <div v-if="Object.keys(business_data).length===0" class="flex_wrap">
                                    <img alt=""
                                         src="https://download.hecoos.com/enlightv/2025-10/d83f6be23fa8ac527f87c9296c8e1e39.svg">
                                    <span v-text="'¥'+customForm.purchase_cost_price"></span>
                                </div>
                                <div class="purchase_price">
                                    <span>总价：</span>
                                    <span class="money_compute_mode_text"
                                          v-text="''+customForm.purchase_price.text"></span>
                                </div>
                            </div>
                        </div>
                        <el-form-item v-if="field.field_key==='total_price'">
                            <div v-if="field.field_key==='total_price'" class="total_price_wrap flex_js_wrap">
                                <div>订单总金额</div>
                                <div class="money_compute_mode_text"
                                     v-text="'¥' + customForm[field.field_key].text"></div>
                            </div>
                        </el-form-item>
                        <el-form-item v-else-if="field.field_key==='payable_amount'"
                                      :prop="field.field_key">
                            <span slot="label">
                                <span v-text="field.field_name"></span>
                                <span v-text="customForm[field.field_key].currency&&customForm[field.field_key].currency.includes('CNY')?'（CNY-人民币）':'（USD-美元）'"></span>
                            </span>
                            <div class="detail_value">
                                <span v-text="customForm[field.field_key].text||'--'"></span>
                                <div v-if="customForm[field.field_key].currency==='CNY'"
                                     class="chinese_text"
                                     v-text="customForm[field.field_key].chinese_text"></div>
                            </div>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <el-image ref="preview_img"
                  :preview-src-list="previewImgList"
                  :src="previewImgSrc"
                  style="display:none">
        </el-image>
        <!--发票详情-->
        <el-dialog v-if="invoiceDetailDialogVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="invoiceDetailDialogVisible"
                   append-to-body
                   title="发票明细"
                   width="820px"
                   custom-class="custom_form_dialog"
                   @close="handleClickInvoiceInfoDialogCancel">
            <ul class="invoice_info_list">
                <li class="invoice_info_item" v-for="item in invoiceFilesList">
                    <div class="invoice_image_wrap">
                        <el-image :preview-src-list="[item.file_path]"
                                  :src="item.file_path"
                                  v-if="item.file_type==='image'">
                        </el-image>
                        <iframe :src="item.file_path" frameborder="0" v-else></iframe>
                    </div>
                    <el-form size="small">
                        <div class="page_little_title"><span class="title">发票基本信息</span></div>
                        <el-form-item prop="op" label="发票类型：">
                            <div v-text="invoiceOptionText(item.op)"></div>
                        </el-form-item>
                        <el-form-item prop="invoice_code" label="发票代码：" v-if="item.invoice_code">
                            <div v-text="item.invoice_code"></div>
                        </el-form-item>
                        <el-form-item prop="invoice_number" label="发票号码：">
                            <div v-text="item.invoice_number"></div>
                        </el-form-item>
                        <el-form-item prop="invoice_date" v-if="item.invoice_date" label="开票日期：">
                            <div v-text="item.invoice_date"></div>
                        </el-form-item>
                        <el-form-item prop="checkCode" v-if="item.check_code" label="校验码：">
                            <div v-text="item.check_code"></div>
                        </el-form-item>
                        <div class="page_little_title"
                             v-if="item.purchaser_name||item.purchaser_tax_number||item.purchaser_contact_info||item.purchaser_bank_account_info">
                            <span class="title">购方信息</span>
                        </div>
                        <el-form-item prop="purchaser_name" v-if="item.purchaser_name" label="名称：">
                            <div v-text="item.purchaser_name"></div>
                        </el-form-item>
                        <el-form-item v-if="item.purchaser_tax_number" label="纳税人识别号："
                                      prop="purchaser_tax_number">
                            <div v-text="item.purchaser_tax_number"></div>
                        </el-form-item>
                        <el-form-item prop="purchaser_contact_info"
                                      label="地址、电话："
                                      v-if="item.purchaser_contact_info">
                            <div v-text="item.purchaser_contact_info"></div>
                        </el-form-item>
                        <el-form-item prop="purchaser_bank_account_info" label="开户行及账号："
                                      v-if="item.purchaser_bank_account_info">
                            <div v-text="item.purchaser_bank_account_info"></div>
                        </el-form-item>
                    </el-form>
                </li>
            </ul>
            <div slot="footer">
                <el-button size="small" @click="handleClickInvoiceInfoDialogCancel">取消</el-button>
                <el-button size="small" type="primary" @click="handleClickInvoiceInfoDialogConfirm">确定</el-button>
            </div>
        </el-dialog>
        <checkRecordDetail v-if="relateCheckRecordDetailVisible"
                           :check_record_id="check_record_id"
                           :dialog-visible.sync="relateCheckRecordDetailVisible"/>
    </div>
</template>
<script>
import {getRelateApproval, getRelateCheckRecord} from "@/api";
import {mapState} from "vuex";
import {getOSSData} from "@/utils/uploadOss";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import {goodsPriceDiscountsText} from "@/utils";
import checkRecordDetail from "@/components/mComponents/checkRecordDetail.vue";
import OverviewFields from "@/components/pComponents/overviewFields.vue";

export default {
    name: "CustomFormDetailMobile",
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            formInfoList: [],
            customForm: {},
            previewImgList: [],
            previewImgSrc: '',
            invoiceDetailDialogVisible: false,
            order_procurement_show: false,
            relateCheckRecordDetailVisible: false,
            check_record_id: 0,
        }
    },
    props: {
        //表单字段数据
        field_list: {
            type: Array,
            default: () => {
                return []
            }
        },
        field_form: {
            type: String,
            default: '',
        },
        //表单详情，编辑时使用
        form_detail: {
            type: Object,
            default: () => {
                return {}
            }
        },
        //表单id
        pk_id: {
            type: Number,
            default: 0
        },
        business_data: {
            type: [Object, Array],
            default: () => {
                return {}
            }
        },
        node_list: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed: {
        ...mapState(['userInfo'])
    },
    created() {
        if (this.field_list.length) {
            const {fieldList, formData} = this.deepCreateFormData(this.field_list)
            this.formInfoList = fieldList
            this.customForm = formData
            if (this.pk_id && Object.keys(this.form_detail).length) {
                this.deepSiteDetailValue(this.formInfoList, this.customForm, this.form_detail)
            }
        }
    },
    mounted() {
    },
    components: {OverviewFields, checkRecordDetail, PersonnelCard},
    methods: {
        //递归生成表单，表单字段列表，表单校验规则
        deepCreateFormData(field_data, is_horizontal_table, parent_field) {
            let fieldList = []
            let formData = {}
            let formDataRules = {}
            field_data.forEach(field => {
                field = {...field, ...field.extend}
                delete field.extend
                if (field.field_type === 'form_module') {
                    field.col_span = 24
                    fieldList.push(field)
                    if (field._child && field._child.length) {
                        const childs = []
                        field._child.forEach(child => {
                            child.p_field_type = field.field_type
                            childs.push(child)
                        })
                        const fieldData = this.deepCreateFormData(childs)
                        fieldList = fieldList.concat(fieldData.fieldList)
                        formData = {...fieldData.formData, ...formData}
                        formDataRules = {...fieldData.formDataRules, ...formDataRules}
                    }
                } else {
                    field.is_required = field.is_required === 1
                    switch (field.field_type) {
                        case 'input':
                            formData[field.field_key] = {
                                value: '',
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (value.value) {
                                        if (field.input_type === 'email') {
                                            const email = value.value.replace(/\s/g, '')
                                            const regs = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
                                            if (!regs.test(email)) return callback(new Error('邮箱格式不正确'))
                                        }
                                        if (field.is_unique === '1') {
                                            callback()
                                            // callback(new Error('文本内容与现有数据重复，请重新输入'))
                                        } else {
                                            callback()
                                        }
                                    } else {
                                        if (field.is_required) {
                                            callback(new Error(field.placeholder || '请输入' + field.field_name))
                                        } else {
                                            callback()
                                        }
                                    }
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '188px'
                            }
                            break
                        case 'textarea':
                            formData[field.field_key] = {
                                value: '',
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && !value.value) return callback(new Error(field.placeholder || '请输入' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '188px'
                            }
                            break
                        case 'number':
                            formData[field.field_key] = {
                                value: undefined,
                                text: '',
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && !value.value) return callback(new Error(field.placeholder || '请输入' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '88px'
                            }
                            break
                        case 'money':
                            formData[field.field_key] = {
                                value: '',
                                text: '',
                                currency: field.currency && field.currency.length ? field.currency[0] : '',
                                chinese_text: '',
                                value_converted: '',
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value === '') return callback(new Error(field.placeholder || '请输入' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '154px'
                            }
                            break
                        case 'compute_mode':
                            formData[field.field_key] = {
                                value: '',
                                text: '',
                                chinese_text: '',
                            }
                            if (is_horizontal_table) {
                                field.min_width = '180px'
                            }
                            break
                        case 'telephone':
                            formData[field.field_key] = {
                                value: '',
                                phone_type: field.phone_type !== '2' ? '1' : '2',
                                prefix: field.phone_type !== '2' ? '+86' : '',
                                direct_dial: field.direct_dial,
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (!value.value && field.is_required) callback(new Error(field.placeholder))
                                    const phone = value.value.replace(/\s/g, '')
                                    if (formData[field.field_key].phone_type === '1') {
                                        const regs = /^1[3456789]\d{9}$/
                                        if (!regs.test(phone) && phone.length > 0) return callback(new Error('输入的手机号不正确，请重新输入'))
                                    } else if (formData[field.field_key].phone_type === '2') {
                                        const regex = /^\d+$/;
                                        if (!formData[field.field_key].prefix) return callback(new Error('请输入区号'))
                                        if (!value.value) return callback(new Error('请输入固定电话'))
                                        if (!regex.test(value.prefix)) return callback(new Error('输入的区号不正确，请重新输入'))
                                        if (!regex.test(value.value)) return callback(new Error('输入的固定号码不正确，请重新输入'))
                                    }
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '167px'
                            }
                            break
                        case 'radio':
                            formData[field.field_key] = {
                                value: '',
                                text: '',
                            }
                            const default_option = field.options ? field.options.find(o => o.default) : {}
                            if (default_option) {
                                formData[field.field_key].value = default_option.value
                                formData[field.field_key].text = default_option.label
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value === '') return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '180px'
                            }
                            break
                        case 'radio_workorder_type':
                            formData[field.field_key] = {
                                value: '',
                                text: '',
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value === '') return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            if (parent_field) {
                                field.p_field_type = parent_field.field_type
                                if (parent_field.hasOwnProperty('filling_method') && parent_field.filling_method === 'horizontal') {
                                    field.min_width = '180px'
                                }
                            }
                            break
                        case 'radio_project_stage':
                            formData[field.field_key] = {
                                value: '',
                                text: '',
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value === '') return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '180px'
                            }
                            break
                        case 'radio_customer':
                            formData[field.field_key] = {
                                value: '',
                                text: ''
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value === '') return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            break
                        case 'radio_project':
                            formData[field.field_key] = {
                                value: '',
                                text: ''
                            }
                            break
                        case 'radio_order':
                            formData[field.field_key] = {
                                value: '',
                                text: ''
                            }
                            break
                        case 'checkbox':
                            formData[field.field_key] = {
                                value: [],
                                text: [],
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value.length === 0) return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '180px'
                            }
                            break
                        case 'checkbox_user_tag':
                            formData[field.field_key] = {
                                value: [1],
                                text: [{
                                    id: 1,
                                    name: '四大天王'
                                }],
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value.length === 0) return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '180px'
                            }
                            break
                        case 'checkbox_quotation':
                            formData[field.field_key] = {
                                value: [],
                                text: [
                                    {
                                        id: 1,
                                        quotation_num: 'BJ-12345',
                                        quoter_name: '张三',
                                        quotation_at: '2024-12-25',
                                    },
                                    {
                                        id: 2,
                                        quotation_num: 'BJ-23456',
                                        quoter_name: '张三',
                                        quotation_at: '2024-12-25',
                                    },
                                ]
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.length === 0) return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            break
                        case 'cascader':
                            formData[field.field_key] = {
                                value: [],
                                text: [],
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value.length === 0) return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '180px'
                            }
                            break
                        case 'date':
                            formData[field.field_key] = {
                                value: '',
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value === '') return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            if (!field.default) {
                                if (field.time_range === 'any') {
                                    field.date_picker_options = {}
                                } else {
                                    if (field.date_type === 'time') {
                                        const now = this.getNowDate('time') + ':00'
                                        if (field.time_range === 'before') {
                                            //当前时间之前
                                            field.date_picker_options = {
                                                selectableRange: '00:00:00 - ' + now
                                            }
                                        } else {
                                            //当前时间之后
                                            field.date_picker_options = {
                                                selectableRange: now + ' - 23:59:59'
                                            }
                                        }
                                    } else {
                                        field.date_picker_options = {
                                            disabledDate(time) {
                                                if (field.time_range === 'before') {
                                                    //当前时间之前
                                                    return time.getTime() > Date.now() - 8.64e7;
                                                } else {
                                                    //当前时间之后
                                                    return time.getTime() < Date.now();
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            if (is_horizontal_table) {
                                field.min_width = '180px'
                            }
                            break
                        case 'date_range':
                            formData[field.field_key] = {
                                value: field.date_type === 'timerange' ? [new Date(2025, 1, 1, 9, 0), new Date(2025, 1, 1, 18, 0)] : [],
                                text: '',
                                duration: ''
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (value.value.length === 0) return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '294px'
                            }
                            break
                        case 'address':
                            formData[field.field_key] = {
                                value: [],
                                text: '',
                                detail_address: ''
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value.length === 0) return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    if (field.is_show_detail_address && field.detail_address_is_required && value.detail_address === '') return callback(new Error(field.detail_address_placeholder || '请输入详细地址'))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = field.is_show_detail_address ? '294px' : '168px'
                            }
                            break
                        case 'contact':
                            if (field.default) {
                                formData[field.field_key] = {
                                    value: [this.userInfo.user.id],
                                    text: [{
                                        id: this.userInfo.user.id,
                                        name: this.userInfo.user.name,
                                        avatar: this.userInfo.user.avatar,
                                    }]
                                }
                            } else {
                                formData[field.field_key] = {
                                    value: [],
                                    text: [],
                                }
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value.length === 0) return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '188px'
                            }
                            break
                        case 'department':
                            formData[field.field_key] = {
                                value: [],
                                text: [],
                                title: [],
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value.length === 0) return callback(new Error(field.placeholder || '请选择' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '188px'
                            }
                            break
                        case 'table':
                            formData[field.field_key] = []
                            const fieldData = this.deepCreateFormData(field._child || [], field.filling_method === 'horizontal')
                            field._child = fieldData.fieldList
                            field.formRules = fieldData.formDataRules
                            formData[field.field_key].push(fieldData.formData)
                            break
                        case 'image':
                            formData[field.field_key] = [
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/fdc98e9591bb7f43f71177680e42eb2c.svg",
                                //     "file_name": "对比.svg",
                                //     "file_type": "image/svg+xml",
                                //     "file_size": "2.99KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/a2ace1b9d6679c800ead0cc29a0b34e8.svg",
                                //     "file_name": "疑问.svg",
                                //     "file_type": "image/svg+xml",
                                //     "file_size": "5.14KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/47bfbb877fd1022830bb10ee67d2236a.jfif",
                                //     "file_name": "4172e0181t882763b6e5a2dc4b0648a7.jfif",
                                //     "file_type": "image/jpeg",
                                //     "file_size": "159.19KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/51b741e71dd7668bd53cf78e4e954393.jpg",
                                //     "file_name": "12619.jpg",
                                //     "file_type": "image/jpeg",
                                //     "file_size": "244.87KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/d006ad2ef5e4a8f0b2181729b4ea193d.jpeg",
                                //     "file_name": "3302e.jpeg",
                                //     "file_type": "image/jpeg",
                                //     "file_size": "124.49KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/7578600553c8771560c28b0deef24195.jpg",
                                //     "file_name": "14696.jpg",
                                //     "file_type": "image/jpeg",
                                //     "file_size": "137.36KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/d414c1fa9c4fa588164582a8c84dbce6.jfif",
                                //     "file_name": "3c5465418md32f589a02e913fb9f8632.jfif",
                                //     "file_type": "image/jpeg",
                                //     "file_size": "175.63KB"
                                // }
                            ]
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value.length === 0) return callback(new Error(field.placeholder || '请上传' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '160px'
                            }
                            break
                        case 'file':
                            formData[field.field_key] = [
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/fdc98e9591bb7f43f71177680e42eb2c.svg",
                                //     "file_name": "对比.svg",
                                //     "file_type": "image/svg+xml",
                                //     "file_size": "2.99KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/a2ace1b9d6679c800ead0cc29a0b34e8.svg",
                                //     "file_name": "疑问.svg",
                                //     "file_type": "image/svg+xml",
                                //     "file_size": "5.14KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/47bfbb877fd1022830bb10ee67d2236a.jfif",
                                //     "file_name": "4172e0181t882763b6e5a2dc4b0648a7.jfif",
                                //     "file_type": "image/jpeg",
                                //     "file_size": "159.19KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/51b741e71dd7668bd53cf78e4e954393.jpg",
                                //     "file_name": "12619.jpg",
                                //     "file_type": "image/jpeg",
                                //     "file_size": "244.87KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/d006ad2ef5e4a8f0b2181729b4ea193d.jpeg",
                                //     "file_name": "3302e.jpeg",
                                //     "file_type": "image/jpeg",
                                //     "file_size": "124.49KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/7578600553c8771560c28b0deef24195.jpg",
                                //     "file_name": "14696.jpg",
                                //     "file_type": "image/jpeg",
                                //     "file_size": "137.36KB"
                                // },
                                // {
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/d414c1fa9c4fa588164582a8c84dbce6.jfif",
                                //     "file_name": "3c5465418md32f589a02e913fb9f8632.jfif",
                                //     "file_type": "image/jpeg",
                                //     "file_size": "175.63KB"
                                // }
                            ]
                            if (field.file_type) {
                                field.file_type = field.file_type.split('、').map(type => type.toLowerCase())
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value.length === 0) return callback(new Error(field.placeholder || '请上传' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '200px'
                            }
                            break
                        case 'checkbox_approval':
                            formData[field.field_key] = {
                                value: [],
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: '请选择' + field.field_name,
                                    validator: (value) => {
                                        return value.length > 0
                                    }
                                }]
                            }
                            break
                        case 'checkbox_check_record':
                            formData[field.field_key] = {
                                value: [],
                            }
                            if (field.is_required === 1) {
                                formDataRules[field.field_key] = [{
                                    required: true,
                                    trigger: 'onChange',
                                    message: '请选择打卡记录',
                                    validator: (value) => {
                                        return value.length > 0
                                    }
                                }]
                            }
                            break
                        case 'id_card':
                            formData[field.field_key] = {
                                value: '',
                            }
                            const idCardFormRules = {}
                            if (field.upload_recognition) {
                                formData[field.field_key].name = ''
                                formData[field.field_key].birthday = ''
                                formData[field.field_key].address = ''
                                idCardFormRules.value = {
                                    required: field.is_required,
                                    trigger: 'blur',
                                    validator: (rule, value, callback) => {
                                        const id_card = value.replace(/\s/g, '')
                                        if (!value) return callback(new Error(field.placeholder))
                                        const regs = /^(\d{17})[\dX]$/;
                                        if (id_card && !regs.test(id_card)) return callback(new Error('身份证号不正确，请重新输入，最后一位如为X请大写'))
                                        callback()
                                    }
                                }
                                if (field.upload_recognition) {
                                    if (field.name_is_show && field.name_is_required) {
                                        idCardFormRules.name = {
                                            required: true,
                                            trigger: 'blur',
                                            validator: (rule, value, callback) => {
                                                const name = value.replace(/\s/g, '')
                                                if (!name) return callback(new Error('请输入姓名'))
                                                callback()
                                            }
                                        }
                                    }
                                    if (field.birthday_is_show && field.birthday_is_required) {
                                        idCardFormRules.birthday = {
                                            required: true,
                                            trigger: 'blur',
                                            validator: (rule, value, callback) => {
                                                if (!value) return callback(new Error('请选择出生日期'))
                                                callback()
                                            }
                                        }
                                    }
                                    if (field.address_is_show && field.address_is_required) {
                                        idCardFormRules.address = {
                                            required: true,
                                            trigger: 'blur',
                                            validator: (rule, value, callback) => {
                                                const address = value.replace(/\s/g, '')
                                                if (!address) return callback(new Error('请输入家庭住址'))
                                                callback()
                                            }
                                        }
                                    }
                                }
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    const id_card = value.value.replace(/\s/g, '')
                                    if (!id_card && field.is_required) return callback(new Error(field.placeholder))
                                    const regs = /^(\d{17})[\dX]$/;
                                    if (id_card && !regs.test(id_card)) return callback(new Error('身份证号不正确，请重新输入，最后一位如为X请大写'))
                                    if (field.upload_recognition) {
                                        const {name, birthday, address} = value
                                        if (!name && field.name_is_show && field.name_is_required) return callback(new Error('请输入姓名'))
                                        if (!birthday && field.birthday_is_show && field.birthday_is_required) return callback(new Error('请选择出生日期'))
                                        if (!address && field.address_is_show && field.address_is_required) return callback(new Error('请输入家庭住址'))
                                    }
                                    callback()
                                }
                            }]
                            this.$set(field, 'idCardFormRules', idCardFormRules)
                            if (is_horizontal_table) {
                                field.min_width = '254px'
                            }
                            break
                        case 'rate':
                            formData[field.field_key] = {
                                value: 0,
                                point_system: field.point_system
                            }
                            if (is_horizontal_table) {
                                field.min_width = '196px'
                            }
                            break
                        case 'paying_teller':
                            formData[field.field_key] = {
                                value: '',
                                text: ''
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value === '') return callback(new Error(field.placeholder || '请输入' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '220px'
                            }
                            break
                        case 'invoice':
                            formData[field.field_key] = [
                                // {
                                //     "op": "invoice",
                                //     "invoice_type": "数电普通发票",
                                //     "invoice_code": "",
                                //     "invoice_number": "24112000000033990251",
                                //     "printed_invoice_code": "",
                                //     "printed_invoice_number": "",
                                //     "check_code": "",
                                //     "invoice_date": "2024年05月06日",
                                //     "title": "电子发票(普通发票)",
                                //     "form_type": "",
                                //     "purchaser_name": "北京澜景科技有限公司",
                                //     "purchaser_tax_number": "91110108351312831B",
                                //     "purchaser_contact_info": "",
                                //     "purchaser_bank_account_info": "",
                                //     "total_amount": "36.10",
                                //     "file_type": "pdf",
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-48/7eac20103a9920a9f529924b847a08c4.pdf"
                                // },
                                // {
                                //     "op": "invoice",
                                //     "invoice_type": "电子普通发票",
                                //     "invoice_code": "011002301711",
                                //     "invoice_number": "29276154",
                                //     "printed_invoice_code": "",
                                //     "printed_invoice_number": "",
                                //     "check_code": "85453022992728593554",
                                //     "invoice_date": "2024年04月30日",
                                //     "title": "北京增值税电子普通发票",
                                //     "form_type": "",
                                //     "purchaser_name": "北京澜景科技有限公司",
                                //     "purchaser_tax_number": "91110108351312831B",
                                //     "purchaser_contact_info": "",
                                //     "purchaser_bank_account_info": "",
                                //     "total_amount": "26.63",
                                //     "file_type": "pdf",
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-48/9c0ba0d1bc9b791f461e9a88f765190b.pdf"
                                // },
                                // {
                                //     "op": "invoice",
                                //     "invoice_type": "电子普通发票",
                                //     "invoice_code": "011002301711",
                                //     "invoice_number": "29276154",
                                //     "printed_invoice_code": "",
                                //     "printed_invoice_number": "",
                                //     "check_code": "85453022992728593554",
                                //     "invoice_date": "2024年04月30日",
                                //     "title": "北京增值税电子普通发票",
                                //     "form_type": "",
                                //     "purchaser_name": "北京澜景科技有限公司",
                                //     "purchaser_tax_number": "91110108351312831B",
                                //     "purchaser_contact_info": "",
                                //     "purchaser_bank_account_info": "",
                                //     "total_amount": "26.63",
                                //     "file_type": "image",
                                //     "file_path": "https://download.hecoos.com/enlightv/2024-46/d006ad2ef5e4a8f0b2181729b4ea193d.jpeg"
                                // },
                            ]
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value.length === 0) return callback(new Error(field.placeholder || '请上传' + field.field_name))
                                    callback()
                                }
                            }]
                            if (is_horizontal_table) {
                                field.min_width = '200px'
                            }
                            break
                        case 'customer_contact':
                            formData[field.field_key] = {
                                value: [],
                                text: [],
                            }
                            formDataRules[field.field_key] = [{
                                required: field.is_required,
                                trigger: 'blur',
                                validator: (rule, value, callback) => {
                                    if (field.is_required && value.value.length === 0) return callback(new Error(field.placeholder || '请新增' + field.field_name))
                                    callback()
                                }
                            }]
                            break
                    }
                    fieldList.push(field)
                }
            })
            fieldList = fieldList.filter(field => field.field_type !== 'location' && field.field_type !== 'serial_number')
            return {
                fieldList,
                formData,
                formDataRules,
            }
        },

        //递归显示详情的值
        deepSiteDetailValue(field_list, formData, details) {
            for (let i = field_list.length - 1; i >= 0; i--) {
                const field = field_list[i];
                if (!details.hasOwnProperty(field.field_key) && field.field_type === 'order_amount_compute_mode') {
                    field_list.splice(i, 1); // 删除符合条件的元素
                }
            }
            field_list.forEach(field => {
                if (details.hasOwnProperty(field.field_key)) {
                    this.$set(formData, field.field_key, details[field.field_key])
                    switch (field.field_type) {
                        case 'department':
                            this.$set(formData[field.field_key], 'titles', this.form_detail[field.field_key].text.map(item => item.department_name))
                            break
                        case 'order_amount_compute_mode':
                            if (field.visible_person_range && field.visible_person_range.length) {
                                const user_id = this.userInfo?.user?.id;
                                const salesperson_ids = this.customForm?.salesperson?.value || [];
                                if (user_id !== undefined && Array.isArray(salesperson_ids)) {
                                    const shouldHideField = field.visible_person_range.some(item => {
                                        return (item.relate_type === 'order_creator' && salesperson_ids.includes(user_id))
                                                || (item.relate_type === 'order_approver' && this.node_list.length && this.node_list.includes(user_id))
                                                || (item.relate_type === 'App\\Models\\User' && item.uid === user_id);
                                    });
                                    if (!shouldHideField) {
                                        this.formInfoList = this.formInfoList.filter(item => item.field_key !== field.field_key)
                                    } else {
                                        if (field.num_display_style === '2') {
                                            formData[field.field_key] = formData[field.field_key].text ? formData[field.field_key].text + '%' : ''
                                        } else {
                                            formData[field.field_key] = formData[field.field_key].text ? '￥' + formData[field.field_key].text : ''
                                        }
                                    }
                                } else {
                                    if (field.num_display_style === '2') {
                                        formData[field.field_key] = formData[field.field_key].text ? formData[field.field_key].text + '%' : ''
                                    } else {
                                        formData[field.field_key] = formData[field.field_key].text ? '￥' + formData[field.field_key].text : ''
                                    }
                                }
                            } else {
                                if (field.num_display_style === '2') {
                                    formData[field.field_key] = formData[field.field_key].text ? formData[field.field_key].text + '%' : ''
                                } else {
                                    formData[field.field_key] = formData[field.field_key].text ? '￥' + formData[field.field_key].text : ''
                                }
                            }
                            break
                        case 'money':
                            if (field.field_key === 'purchase_price') {
                                if (Number(formData[field.field_key].value) > 0) {
                                    this.order_procurement_show = true
                                }
                            }
                            break
                        case 'radio':
                            if (field.field_key === 'is_deliver' && formData[field.field_key].value === 0) {
                                this.formInfoList = this.formInfoList.filter(item => item.field_key !== 'receive_name' && item.field_key !== 'receive_phone' && item.field_key !== 'receive_addr')
                            }
                            break
                        case 'table':
                            if (details[field.field_key].length) {
                                details[field.field_key].forEach(row => {
                                    this.deepSiteDetailValue(field._child, row, row)
                                })
                            }
                            break
                        case 'checkbox_approval':
                            if (formData[field.field_key].value && formData[field.field_key].value.length) {
                                getRelateApproval({
                                    approval_ids: formData[field.field_key].value
                                }).then(res => {
                                    if (res.code === 200) {
                                        this.$set(formData[field.field_key], 'text', res.data.data)
                                    }
                                })
                            }
                            break
                        case 'checkbox_check_record':
                            if (formData[field.field_key].value && formData[field.field_key].value.length) {
                                getRelateCheckRecord({
                                    attendance_check_record_ids: formData[field.field_key].value
                                }).then(res => {
                                    if (res.code === 200) {
                                        this.$set(formData[field.field_key], 'text', res.data.data)
                                    }
                                })
                            }
                            break
                    }
                }
            })
            if (this.field_form === 'orders') {
                formData.purchase_cost_price = details.purchase_cost_price
            }
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name || file.title);
        },

        //预览发票文件
        handleClickPreviewInvoiceFile(invoice) {
            this.invoiceFilesList = [invoice]
            this.invoiceInfoPreview = true
            this.invoiceDetailDialogVisible = true
        },

        // 商品优惠信息
        goodsDiscountsTextOrClass(row, key) {
            return goodsPriceDiscountsText(row)[key]
        },

        //点击查看订单代采明细
        handleClickShowPurchaseDetail() {
            this.$emit('show-purchase-detail')
        },

        //点击打开组合产品的配置
        handleClickExpandConfig(row) {
            if (row.hasOwnProperty('is_expand')) {
                row.is_expand = !row.is_expand
            } else {
                this.$set(row, 'is_expand', true)
            }
        },

        //点击查看关联客户详情
        handleClickRelateCompanyDetail() {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: this.customForm.customer_id.value,
                    name: this.customForm.customer_id.text,
                },
            });
        },

        //点击查看关联商机详情
        handleClickRelateProjectDetail() {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: this.customForm.project_id.value,
                    name: this.customForm.project_id.text,
                },
            });
        },

        handleClickShowFormula(formula) {
            this.$dialog.alert({
                title: '订单金额公式',
                message: formula,
                confirmButtonColor: '#2990ff'
            }).then(() => {
                return false
            }).catch(() => {
                return false
            })
        },

        //关联打卡记录详情
        handleClickRelatedCheckRecordDetail(item) {
            this.check_record_id = item.id
            this.relateCheckRecordDetailVisible = true
        },

        //关联审批单详情
        handleClickRelatedApprovalDetail(item) {
            this.$showApprovalDetail({
                approval_id: item.id,
            }).then((res) => {

            });
        },
    },
}
</script>
<style lang="scss">
.m_custom_form_detail_wrap {
    width: 100%;

    .form_module_title {
        height: 24px;
        padding-left: 12px;
        position: relative;
        margin-bottom: 12px;

        &::before {
            content: '';
            width: 4px;
            height: 24px;
            opacity: 1;
            border-radius: 20px;
            background: #2990FF;
            position: absolute;
            left: 0;
        }

        .field_name {
            display: inline-block;
            line-height: 24px;
            color: #333333;
            font-weight: 700;
            font-size: 16px;
        }

        .parse_info_btn {
            color: #1990ff;
            cursor: pointer;
            line-height: 22px;
            display: inline-block;
            margin-left: 4px;

            .icon-shibiewenzi {
                font-size: 14px;
                margin-right: 4px;
            }
        }
    }

    .el-form-item {
        margin-bottom: 12px;
    }

    .el-form-item__label {
        color: #999999 !important;
        margin-bottom: 2px !important;
        font-size: 12px;
        line-height: 18px !important;
    }

    .el-form-item__content {
        line-height: 22px;
    }

    .image_outer_wrap {
        padding-left: 6px;

        .image_upload_wrap {
            width: 48px;
            height: 48px;
            opacity: 1;
            border-radius: 4px;
            background: #EDF0F4;
            border: 1px dashed #D9D9D9;
            text-align: center;
            line-height: 48px;
            margin-bottom: 2px;
            cursor: pointer;
            position: relative;

            .upload_input {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                opacity: 0;
                cursor: pointer;
            }
        }

        .upload_image_list {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .upload_image_item {
                width: 48px;
                height: 48px;
                opacity: 1;
                border-radius: 4px;
                text-align: center;
                line-height: 48px;
                position: relative;

                .el-image {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                }
            }
        }

        .image_hint {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: #999999;
        }
    }

    .file_outer_wrap {
        height: 156px;
        opacity: 1;
        border-radius: 6px;
        background: #EDF0F4;
        border: 1px dashed #D9D9D9;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        position: relative;

        .upload_input {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 100;
            opacity: 0;
            cursor: pointer;
            width: 100%;
        }

        .file_hint {
            margin-top: 12px;
            margin-bottom: 4px;
            line-height: 22px;
            color: #666666;
        }

        .file_type_hint {
            color: #999999;
            font-size: 12px;
            line-height: 18px;
        }
    }

    .detail_value {
        color: #333333;

        .flex_wrap {
            flex-wrap: wrap;
        }
    }

    .handle_icon_wrap {
        width: 18px;
        height: 18px;
        line-height: 18px;

        i {
            font-size: 12px;
        }
    }

    .file_upload_detail_wrap {
        height: auto;

        .upload_file_item {
            padding: 0 8px;

            .file_name {
                margin-bottom: 0 !important;
            }
        }
    }

    .total_price_wrap {
        margin: 0 -16px;
        line-height: 22px;
        padding: 8px 16px;
        background: #EDF0F4;
    }

    .money_compute_mode_text {
        font-weight: 700;
        line-height: 22px;
        color: #333333;
    }
}
</style>